import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { authApi, newAuthApi } from "./services/auth";
import { companyApi } from "./services/company";
import { constantApi } from "./services/constants";
import { emissionsApi } from "./services/emissions";
import { buyersApi } from "./services/master/buyers";
import { productsApi } from "./services/master/products";
import { suppliersApi } from "./services/master/suppliers";
import { newUserApi, usersApi } from "./services/users";
import authReducer from "./slices/authSlice";
import { activitiesApi } from "./services/emissionActivities";
import { reportsapigri } from "./services/grireport";
import { reportss3api } from "./services/s3";
import { targetsettingapi } from "./services/TargetSettingapi";
import { targetdashboardapi } from "./services/TargetDashboard";
import { inputGroupApi } from "./services/inputGroup";
import { inputItemsApi } from "./services/inputItems";
import { dashboardApi } from "./services/dashboard";
import { sectorApi } from "./services/sector";
import { categoryApi } from "./services/category";
import { targetApi } from "./services/emissionTarget";
import { reportsApi } from "./services/reports";
import { taxonomiesApi } from "./services/taxonomies";
import { taskApi } from "./services/tasks";
import { commentsApi } from "./services/comments";
import { emissionTargetGroupAndItemApi } from "./services/emissionTargetGroupAndItem";
import { analyticsApi } from "./services/analytics";
import { supplierInviteApi } from "./services/supplierInvite";
import { baseMetricsApi } from "./services/baseMetrics";
import { Uploadstream } from "./services/Uploadstream";
import { esgactivites } from "./services/esg";
import { uncertaintyAnalysisApi } from "./services/UncertaintyAnalysis";
import { Uploads3stream } from "./services/s3fileupload";
import { esgmoduleactivites } from "./services/esgmodule";

const setUpStore = () => {
  const store = configureStore({
    reducer: {
      [authApi.reducerPath]: authApi.reducer,
      [newAuthApi.reducerPath]: newAuthApi.reducer,
      [usersApi.reducerPath]: usersApi.reducer,
      [newUserApi.reducerPath]: newUserApi.reducer,
      [companyApi.reducerPath]: companyApi.reducer,
      [emissionsApi.reducerPath]: emissionsApi.reducer,
      [buyersApi.reducerPath]: buyersApi.reducer,
      [productsApi.reducerPath]: productsApi.reducer,
      [suppliersApi.reducerPath]: suppliersApi.reducer,
      [constantApi.reducerPath]: constantApi.reducer,
      [esgactivites.reducerPath]: esgactivites.reducer,
      [esgmoduleactivites.reducerPath]: esgmoduleactivites.reducer,
      [Uploads3stream.reducerPath]: Uploads3stream.reducer,
      [Uploadstream.reducerPath]: Uploadstream.reducer,

      [activitiesApi.reducerPath]: activitiesApi.reducer,
      [reportsapigri.reducerPath]: reportsapigri.reducer,
      [reportss3api.reducerPath]: reportss3api.reducer,
      [targetsettingapi.reducerPath]: targetsettingapi.reducer,

      [targetdashboardapi.reducerPath]: targetdashboardapi.reducer,

      [inputGroupApi.reducerPath]: inputGroupApi.reducer,
      [inputItemsApi.reducerPath]: inputItemsApi.reducer,
      [dashboardApi.reducerPath]: dashboardApi.reducer,
      [sectorApi.reducerPath]: sectorApi.reducer,
      [categoryApi.reducerPath]: categoryApi.reducer,
      [targetApi.reducerPath]: targetApi.reducer,
      [reportsApi.reducerPath]: reportsApi.reducer,
      [taxonomiesApi.reducerPath]: taxonomiesApi.reducer,
      [taskApi.reducerPath]: taskApi.reducer,
      [commentsApi.reducerPath]: commentsApi.reducer,
      [analyticsApi.reducerPath]: analyticsApi.reducer,
      [supplierInviteApi.reducerPath]: supplierInviteApi.reducer,
      [emissionTargetGroupAndItemApi.reducerPath]:
        emissionTargetGroupAndItemApi.reducer,
      [baseMetricsApi.reducerPath]: baseMetricsApi.reducer,
      [uncertaintyAnalysisApi.reducerPath]: uncertaintyAnalysisApi.reducer,
      auth: authReducer,
    },
    middleware: (getDM) => [
      ...getDM(),
      authApi.middleware,
      newAuthApi.middleware,
      usersApi.middleware,
      newUserApi.middleware,
      companyApi.middleware,
      emissionsApi.middleware,
      Uploadstream.middleware,
      buyersApi.middleware,
      productsApi.middleware,
      suppliersApi.middleware,
      constantApi.middleware,
      activitiesApi.middleware,
      Uploads3stream.middleware,
      reportsapigri.middleware,
      reportss3api.middleware,
      targetsettingapi.middleware,
      targetdashboardapi.middleware,
      inputGroupApi.middleware,
      inputItemsApi.middleware,
      dashboardApi.middleware,
      esgactivites.middleware,
      esgmoduleactivites.middleware,
      sectorApi.middleware,
      categoryApi.middleware,
      targetApi.middleware,
      reportsApi.middleware,
      taxonomiesApi.middleware,
      taskApi.middleware,
      commentsApi.middleware,
      emissionTargetGroupAndItemApi.middleware,
      analyticsApi.middleware,
      supplierInviteApi.middleware,
      baseMetricsApi.middleware,
      uncertaintyAnalysisApi.middleware,
    ],
  });
  setupListeners(store.dispatch);
  return store;
};

export const store = setUpStore();
